import { render, staticRenderFns } from "./BroadcastMessageConfig.vue?vue&type=template&id=09f3bd08&scoped=true"
import script from "./BroadcastMessageConfig.vue?vue&type=script&lang=js"
export * from "./BroadcastMessageConfig.vue?vue&type=script&lang=js"
import style0 from "./BroadcastMessageConfig.vue?vue&type=style&index=0&id=09f3bd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3bd08",
  null
  
)

export default component.exports